import PropTypes from 'prop-types';
import {
	Button,
	Typography,
} from '@material-ui/core';

import useStyles from './LastUpdated.styled';
import LoadingIcon from '../LoadingIcon';
import TimeAgo from '../TimeAgo';
import { useWeather } from '../../hooks/Weather';
import { useGlobalState } from '../../hooks/GlobalState';

const propTypes = {
	location: PropTypes.shape({
		date: PropTypes.number,
		city: PropTypes.string,
		country: PropTypes.string,
	}).isRequired,
};

const LastUpdated = ({ location }) => {
	const classes = useStyles();
	const { getWeather } = useWeather();
	const [{ loading }] = useGlobalState();

	const updateWeather = () => getWeather({
		city: location.city,
		country: location.country,
	});

	return (
		<div className={classes.container}>
			<Button
				className={classes.button}
				onClick={updateWeather}
			>
				<LoadingIcon
					loading={loading}
					size={18}
				/>
			</Button>
			<Typography variant="body1">
				<TimeAgo date={location.date} />
			</Typography>
		</div>
	);
};

LastUpdated.propTypes = propTypes;

export default LastUpdated;
